import {post, get, put, del} from '@/utils/request'

/**
 * 查询菜单
 * @param data
 * @returns {*}
 */
export function listMenuAPI(data) {
  return get({
    data,
    url: 'member/menus'
  })
}

/**
 * 查询菜单
 * @param data
 * @returns {*}
 */
export function getMenuAPI(id) {
  return get({
    url: `member/menus/${id}`
  })
}

/**
 * 查询树形菜单
 * @param data
 * @returns {*}
 */
export function getMenuTreeAPI(data) {
  return get({
    url: `member/menus/tree`,
    params: data,
  })
}

/**
 * 添加菜单
 * @param data
 * @returns {*}
 */
export function addMenuAPI(data) {
  return post({
    url: `member/menus`,
    data: data,
  })
}

/**
 * 修改菜单
 * @param data
 * @returns {*}
 */
export function updateMenuAPI(data) {
  return put({
    url: `member/menus`,
    data: data,
  })
}

/**
 * 删除菜单
 * @param data
 * @returns {*}
 */
export function deleteMenuAPI(id) {
  return del({
    url: `member/menus/${id}`
  })
}
